import { NotificationContainer, NotificationRenderProps } from "@hex-insights/core";
import styles from "./styles.module.css";

export function SubFormSuccessNotification(props: NotificationRenderProps) {
	return <NotificationContainer {...props} className={styles["sub-form-success-notification"]} />;
}

export function SubFormValidationFailureNotification(props: NotificationRenderProps) {
	return (
		<NotificationContainer variant="warning" {...props}>
			Unable to continue. Please fix the errors in the form.
		</NotificationContainer>
	);
}
